import gql from 'graphql-tag';

export default gql`
query getAppsByPrefix(
        $lang: String!,
        $prefix: String!,
        $len: Int!,
        $iter: Int!
        ) {
    listAppsByPrefix(
          lang: $lang,
          prefix: $prefix,
          len: $len,
          iter: $iter
    ) {
      items {
        uuid

        # Publisher language (deduced from preferences/browser)
        lang

        data
        # user    # the publisher
        # origin  # uuid, for translations only

        # image  # uuid of the cover image

        # # Location (deduced from the first endpoint)
        # travelType
        # lat
        # lon
        # coords

        # # App info
        # name
        # desc

        # # Price / Financial
        # type # 0: free, 1: rent only, 2: buy only, 3: rent or buy
        # rentPrice
        # rentDays
        # buyPrice
        # promoted

        # duration
        # len
      }
    }
}
`;
